<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  data () {
    return {
    }
  },
  computed: {

  },
}
</script>

<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
  overflow: auto !important;
  scrollbar-width: none;
}
#app::-webkit-scrollbar {
    display: none;
}
:focus { outline: 0 }

body .el-table colgroup.gutter {
  display: table-cell !important;
}

table {
  width: 100% !important;
}

wave {
  height: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue